import { BundleName, ParamName, Item } from '../model/analytics-config';
import { logAnalytics } from './log-analytics';
import { getAppConfig } from '../../common/helpers/configs';
import { AnalyticsErrorAux, logAnalyticsError } from './log-analytics-error';

type AnalyticsAddToCart = {
  brandId: string;
  companyId: string;
  items: Item[];
};

const event = 'add_to_cart';

export function logAddToCart({ brandId, companyId, items }: AnalyticsAddToCart) {
  logAnalytics({
    event,
    [BundleName.ECOMMERCE]: {
      [ParamName.AGGREGATOR_ID]: getAppConfig().aggregator,
      [ParamName.BRAND_ID]: brandId,
      [ParamName.COMPANY_ID]: companyId,
      [ParamName.ITEMS]: items,
    },
  });
}

export function logAddToCartError({ errorMessage, errorCode }: AnalyticsErrorAux) {
  logAnalyticsError({ event, errorMessage, errorCode });
}
